import styled from "styled-components";

export const Heading = styled.span`
  font-weight: bold;
  display: block;
  letter-spacing: 0.9rem;
  margin-bottom: 10px;
`;
